module.exports = __webpack_public_path__ + "static/media/Casserole.ae1e106c.png";